import React, { Fragment } from 'react';
import { Button, Tag } from 'antd';

export default function IsApproved({ isApproved, approve }) {
  return (isApproved) ?
    <Tag color="green">Approved</Tag> :
    <Fragment>
      <Tag color="volcano">Not approved</Tag>
      {approve ?
        <Button className="btn-success">Approve</Button> :
        null
      }
    </Fragment>;
}



// WEBPACK FOOTER //
// ./src/components/IsApproved/index.js